export const TEXT = {
  pageTitle: {
    ko: 'RESERVATION',
    en: 'RESERVATION',
    fr: 'RESERVATION'
  },
  reservationDate: {
    ko: '예약일',
    en: 'Reservation Date',
    fr: 'Date de réservation'
  },
  instagram: {
    ko: '인스타그램',
    en: 'Instagram',
    fr: 'Instagram'
  },
  customerName: {
    ko: '고객명',
    en: 'Customer Name',
    fr: 'Nom'
  },
  price: {
    ko: '가격',
    en: 'Price',
    fr: 'Prix'
  },
  deposit: {
    ko: '선금',
    en: 'Deposit',
    fr: 'Acompte'
  },
  subsidy: {
    ko: '보증금',
    en: 'Deposit',
    fr: 'Acompte'
  },
  creationDate: {
    ko: '생성일',
    en: 'Created Date',
    fr: 'Date de création'
  },
  depositPending: {
    ko: '선금대기중',
    en: 'Deposit Pending',
    fr: 'Acompte en attente'
  },
  depositReceived: {
    ko: '선금받음',
    en: 'Deposit Received',
    fr: 'Acompte reçu'
  },
  notReceived: {
    ko: '미수령',
    en: 'Not Received',
    fr: 'Non reçu'
  },
  received: {
    ko: '수령완료',
    en: 'Received',
    fr: 'Reçu'
  },
  finalPayment: {
    ko: '최종 결제',
    en: 'Final Payment',
    fr: 'Paiement final'
  },
  finalPaymentReceived: {
    ko: '결제완료',
    en: 'Payment Received',
    fr: 'Paiement reçu'
  },
  finalPaymentPending: {
    ko: '결제대기',
    en: 'Payment Pending',
    fr: 'Paiement en attente'
  },
  remainingAmount: {
    ko: '잔금',
    en: 'Remaining',
    fr: 'Reste'
  },
  manualReservationDetails: {
    ko: '예약 상세',
    en: 'Reservation Details',
    fr: 'Détail réservation'
  },
  reservationType: {
    ko: '예약타입',
    en: 'Reservation Type',
    fr: 'Type de réservation'
  },
  email: {
    ko: '이메일',
    en: 'Email',
    fr: 'E-mail'
  },
  phone: {
    ko: '전화번호',
    en: 'Phone',
    fr: 'Téléphone'
  },
  minPrice: {
    ko: '최소 가격',
    en: 'Min Price',
    fr: 'Prix min'
  },
  maxPrice: {
    ko: '최대 가격',
    en: 'Max Price',
    fr: 'Prix max'
  },
  depositAmount: {
    ko: '선금 금액',
    en: 'Deposit Amount',
    fr: 'Montant acompte'
  },
  depositReceivedDate: {
    ko: '선금받은날짜',
    en: 'Deposit Received Date',
    fr: 'Date de réception acompte'
  },
  depositPlatform: {
    ko: '선금받은플랫폼',
    en: 'Deposit Platform',
    fr: 'Plateforme acompte'
  },
  paypal: {
    ko: '페이팔',
    en: 'PayPal',
    fr: 'PayPal'
  },
  lydia: {
    ko: '리디아',
    en: 'Lydia',
    fr: 'Lydia'
  },
  cash: {
    ko: '현금',
    en: 'Cash',
    fr: 'Espèces'
  },
  bankTransfer: {
    ko: '계좌이체',
    en: 'Bank Transfer',
    fr: 'Virement bancaire'
  },
  other: {
    ko: '기타',
    en: 'Other',
    fr: 'Autre'
  },
  connectedEvent: {
    ko: '연결된 일정',
    en: 'Connected Event',
    fr: 'Événement connecté'
  },
  title: {
    ko: '제목',
    en: 'Title',
    fr: 'Titre'
  },
  noTitle: {
    ko: '제목 없음',
    en: 'No Title',
    fr: 'Sans titre'
  },
  start: {
    ko: '시작',
    en: 'Start',
    fr: 'Début'
  },
  end: {
    ko: '종료',
    en: 'End',
    fr: 'Fin'
  },
  status: {
    ko: '상태',
    en: 'Status',
    fr: 'Statut'
  },
  confirmed: {
    ko: '확정',
    en: 'Confirmed',
    fr: 'Confirmé'
  },
  pending: {
    ko: '대기',
    en: 'Pending',
    fr: 'En attente'
  },
  cancelled: {
    ko: '취소',
    en: 'Cancelled',
    fr: 'Annulé'
  },
  allDay: {
    ko: '하루종일',
    en: 'All Day',
    fr: 'Toute la journée'
  },
  yes: {
    ko: '예',
    en: 'Yes',
    fr: 'Oui'
  },
  noConnectedEvent: {
    ko: '연결된 일정 없음',
    en: 'No Connected Event',
    fr: 'Aucun événement connecté'
  },
  memo: {
    ko: '메모',
    en: 'Memo',
    fr: 'Mémo'
  },
  enterMemo: {
    ko: '메모를 입력하세요...',
    en: 'Enter memo...',
    fr: 'Entrez le mémo...'
  },
  designImage: {
    ko: '디자인 이미지',
    en: 'Design Image',
    fr: 'Image de design'
  },
  image: {
    ko: '이미지',
    en: 'Image',
    fr: 'Image'
  },
  design: {
    ko: '디자인',
    en: 'Design',
    fr: 'Design'
  },
  editConfirm: {
    ko: '수정확인',
    en: 'Confirm Edit',
    fr: 'Confirmer modification'
  },
  edit: {
    ko: '수정',
    en: 'Edit',
    fr: 'Modifier'
  },
  depositConfirm: {
    ko: '선금확인',
    en: 'Confirm Deposit',
    fr: 'Confirmer acompte'
  },
  depositCancel: {
    ko: '선금철회',
    en: 'Cancel Deposit',
    fr: 'Annuler acompte'
  },
  deleteChoice: {
    ko: '삭제 방식 선택',
    en: 'Choose Delete Method',
    fr: 'Choisir méthode de suppression'
  },
  hasConnectedEvent: {
    ko: '이 수동예약에는 연결된 일정이 있습니다.',
    en: 'This manual reservation has a connected event.',
    fr: 'Cette réservation manuelle a un événement connecté.'
  },
  chooseDeleteMethod: {
    ko: '삭제 방식을 선택해주세요:',
    en: 'Please choose the delete method:',
    fr: 'Veuillez choisir la méthode de suppression :'
  },
  note: {
    ko: '참고:',
    en: 'Note:',
    fr: 'Note :'
  },
  deleteReservationOnlyNote: {
    ko: '"예약만 삭제" 선택 시 연결된 일정은 유지됩니다.',
    en: 'When "Delete Reservation Only" is selected, the connected event will be preserved.',
    fr: 'Lorsque "Supprimer uniquement la réservation" est sélectionné, l\'événement connecté sera préservé.'
  },
  deleteReservationAndEvent: {
    ko: '예약과 일정 삭제',
    en: 'Delete Reservation and Event',
    fr: 'Supprimer réservation et événement'
  },
  deleteReservationOnly: {
    ko: '예약만 삭제',
    en: 'Delete Reservation Only',
    fr: 'Supprimer uniquement la réservation'
  },
  goBack: {
    ko: '뒤로가기',
    en: 'Go Back',
    fr: 'Retour'
  },
  reallyDelete: {
    ko: '정말 삭제하시겠습니까?',
    en: 'Are you sure you want to delete?',
    fr: 'Êtes-vous sûr de vouloir supprimer ?'
  },
  depositConfirmSuccess: {
    ko: '선금확인되었습니다!',
    en: 'Deposit confirmed!',
    fr: 'Acompte confirmé !'
  },
  depositCancelSuccess: {
    ko: '선금철회되었습니다!',
    en: 'Deposit cancelled!',
    fr: 'Acompte annulé !'
  },
  depositConfirmFailed: {
    ko: '선금확인 실패: ',
    en: 'Deposit confirmation failed: ',
    fr: 'Échec de confirmation d\'acompte : '
  },
  depositCancelFailed: {
    ko: '선금철회 실패: ',
    en: 'Deposit cancellation failed: ',
    fr: 'Échec d\'annulation d\'acompte : '
  },
  depositProcessError: {
    ko: '선금 처리 중 오류가 발생했습니다: ',
    en: 'An error occurred during deposit processing: ',
    fr: 'Une erreur s\'est produite lors du traitement de l\'acompte : '
  },
  depositConfirmWithTime: {
    ko: '선금확인되었습니다!\n현재 시간 ({date} {time})이 자동으로 설정되었습니다.',
    en: 'Deposit confirmed!\nCurrent time ({date} {time}) has been automatically set.',
    fr: 'Acompte confirmé !\nL\'heure actuelle ({date} {time}) a été automatiquement définie.'
  },
  unknownError: {
    ko: '알 수 없는 오류',
    en: 'Unknown error',
    fr: 'Erreur inconnue'
  },
  networkError: {
    ko: '네트워크 오류',
    en: 'Network error',
    fr: 'Erreur réseau'
  },
  loading: {
    ko: '로딩 중...',
    en: 'Loading...',
    fr: 'Chargement...'
  },
  noData: {
    ko: '수동예약이 없습니다',
    en: 'No manual reservations',
    fr: 'Aucune réservation manuelle'
  },
  search: {
    ko: '검색',
    en: 'Search',
    fr: 'Rechercher'
  },
  saveSuccess: {
    ko: '저장되었습니다',
    en: 'Saved successfully',
    fr: 'Enregistré avec succès'
  },
  saveError: {
    ko: '저장 실패',
    en: 'Save failed',
    fr: 'Échec d\'enregistrement'
  },
  tableCapture: {
    ko: '테이블 캡처',
    en: 'Table Capture',
    fr: 'Capture de tableau'
  },
  csvFile: {
    ko: 'CSV 파일',
    en: 'CSV File',
    fr: 'Fichier CSV'
  },
  backupAsTable: {
    ko: '표로백업하기',
    en: 'Backup as Table',
    fr: 'Sauvegarder en tableau'
  },
  downloadCSV: {
    ko: 'CSV 다운로드',
    en: 'Download CSV',
    fr: 'Télécharger CSV'
  },
  manualReservationDeleted: {
    ko: '수동예약이 삭제되었습니다.',
    en: 'Manual reservation has been deleted.',
    fr: 'La réservation manuelle a été supprimée.'
  },
  deleteWithEventSuccess: {
    ko: '수동예약과 연결된 일정이 모두 삭제되었습니다.',
    en: 'Manual reservation and connected event have been deleted.',
    fr: 'La réservation manuelle et l\'événement connecté ont été supprimés.'
  },
  delete: {
    ko: '삭제',
    en: 'Delete',
    fr: 'Supprimer'
  },
  close: {
    ko: '닫기',
    en: 'Close',
    fr: 'Fermer'
  },
  update: {
    ko: '수정',
    en: 'Update',
    fr: 'Modifier'
  },
  type: {
    ko: '타입',
    en: 'Type',
    fr: 'Type'
  },
  flash: {
    ko: '플래시',
    en: 'Flash',
    fr: 'Flash'
  },
  personalProject: {
    ko: '개인프로젝트',
    en: 'Personal Project',
    fr: 'Projet personnel'
  },
  retouch: {
    ko: '리터치',
    en: 'Retouch',
    fr: 'Retouche'
  }
};
